export default __webpack_public_path__ + "static/media/grafema-studio.0ceecc90.mp4";